import EntityConstants from "../../configs/EntityConstants";
import { GET } from "../../service/CRUDService";

export const fetchOrganisationsAPI = async (
  tenantCode,
  offset = 0,
  limit = 10
) => {
  try {
    const params = new URLSearchParams({
      tenant_code: tenantCode ?? "",
      limit: String(limit),
      offset: String(offset),
    });
    const res = await GET(
      `${EntityConstants.GET_ORGANISATIONS}?${params.toString()}`
    );
    if (!res.ok) {
      throw new Error(`Failed to fetch organisations (${res.status})`);
    }
    const data = await res.json();

    if (!data.success) {
      throw new Error(data.message || "Failed to fetch organisations");
    }

    if (data.data.count === 0 || data.data.results.length === 0) {
      return {
        options: [{ name: "All Organisations", value: "" }],
        next: null,
        hasMore: false,
        count: 0,
      };
    }

    const activeOrgs = data.data.results.filter((org) => org.is_active);

    const opts = [
      { name: "All Organisations", value: "" },
      ...activeOrgs.map((org) => ({
        name: org.org_name,
        value: org.org_code,
        count: 0,
      })),
    ];

    return {
      options: opts,
      next: data.data.next,
      hasMore: data.data.next !== null,
      count: data.data.count,
    };
  } catch (err) {
    console.error("Failed to fetch organisations:", err);
    return {
      options: [{ name: "All Organisations", value: "" }],
      next: null,
      hasMore: false,
      count: 0,
    };
  }
};
